import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { AcceptCashOnly } from '@sorare/core/src/components/settings/AcceptCashOnly';
import { AcceptedCurrencies } from '@sorare/core/src/components/settings/AcceptedCurrencies';
import { DisableConversionCreditPreselection } from '@sorare/core/src/components/settings/DisableConversionCreditPreselection';
import { PaymentMethods } from '@sorare/core/src/components/settings/PaymentMethods';
import { PostalAddress } from '@sorare/core/src/components/settings/PostalAddress';
import { PreferredPaymentMethods } from '@sorare/core/src/components/settings/PreferredPaymentMethods';
import { RewardCurrency } from '@sorare/core/src/components/settings/RewardCurrency';
import {
  SettingsPage,
  TITLES,
} from '@sorare/core/src/components/settings/pages';

import { SettingsWrapper } from 'components/settings/SettingsWrapper';

export const Payment = () => {
  return (
    <SettingsWrapper pageTitle={TITLES[SettingsPage.PAYMENT]}>
      <Vertical gap={2}>
        <PaymentMethods />
        <PreferredPaymentMethods />
        <AcceptedCurrencies />
        <AcceptCashOnly />
        <RewardCurrency />
        <DisableConversionCreditPreselection />
        <PostalAddress />
      </Vertical>
    </SettingsWrapper>
  );
};

export default Payment;
